import { useCallback, useEffect, useRef } from "react";
import { useLoaderData } from "react-router-dom";

import {
  inject,
  ServiceNotRegistered,
} from "../../../../../../lib/itn-ui-kit/services/service-container";
import { getModalHandler } from "../../../Common/Modals/hooks/useModalSingleton";
import { useViewDetailStore } from "../store/viewDetailStore";

import useViewNavigationService from "./useViewNavigationService";

export default function useFetchData() {
  const { viewName, id } = useLoaderData();
  const { setLoading, setInitialViewDetail, setModifiedViewDetail } = useViewDetailStore();
  const { ensureCanAccessView, navigateToNotFound } = useViewNavigationService();
  const { openFailureModal } = getModalHandler();
  const openFailureModalRef = useRef(openFailureModal);

  useEffect(() => {
    openFailureModalRef.current = openFailureModal;
  }, [openFailureModal]);

  const fetchViewDetails = useCallback(async () => {
    if (!id) {
      return;
    }

    if (!ensureCanAccessView(viewName, true)) {
      return;
    }

    try {
      setLoading(true);
      const repositoryKey = `repositories/${viewName}-repository`;
      const viewRepository = inject(repositoryKey);

      const response = await viewRepository.findRecord(id, {
        noCache: true,
      });
      setInitialViewDetail(response);
      setModifiedViewDetail(response);
    } catch (error) {
      if (error instanceof ServiceNotRegistered) {
        navigateToNotFound(true);
        return;
      }
      console.error("Error fetching view data:", error);
      openFailureModalRef.current(error);
    } finally {
      setLoading(false);
    }
  }, [
    id,
    viewName,
    ensureCanAccessView,
    navigateToNotFound,
    setLoading,
    setInitialViewDetail,
    setModifiedViewDetail,
  ]);

  return { fetchViewDetails };
}
